import { useAdminShortcut } from '@/hooks/useAdminShortcut';
import { ReactNode } from 'react';

interface AdminShortcutProviderProps {
  children: ReactNode;
}

/**
 * Provider component that enables Ctrl+Shift+A keyboard shortcut for admin access
 * Must be placed inside BrowserRouter to have access to navigation
 */
export function AdminShortcutProvider({ children }: AdminShortcutProviderProps) {
  useAdminShortcut();
  return <>{children}</>;
}
